// API Configuration
export const API_CONFIG = {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || 'https://tsoptpcnmjucygpsgwmz.supabase.co',
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRzb3B0cGNubWp1Y3lncHNnd216Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkwMDg1NTAsImV4cCI6MjA2NDU4NDU1MH0.j32dP2k_eS_y0zJnH54IRTV4IicHdBEp8XSDA_Rf_Uo'
}

// Application Constants
export const APP_CONFIG = {
  NAME: 'Qmed Nursing Care Plan',
  VERSION: '1.0.0',
  AUTHOR: 'Qmed Healthcare',
  DESCRIPTION: 'Comprehensive nursing care plans for healthcare professionals'
}

// PGIE Structure Constants
export const PGIE_STRUCTURE = {
  PROBLEMS_COUNT: 4,
  GOALS_COUNT: 4,
  INTERVENTIONS_COUNT: 8,
  EVALUATION_COUNT: 4
}

// Search Configuration
export const SEARCH_CONFIG = {
  MAX_SUGGESTIONS: 5,
  MIN_QUERY_LENGTH: 1,
  SUGGESTION_DELAY: 200
}

// Navigation Routes
export const ROUTES = {
  HOME: '/',
  SPECIALTY: '/specialty/:specialtyId',
  CARE_PLAN: '/care-plan/:carePlanId',
  SEARCH: '/search',
  FEEDBACK_ADMIN: '/feedback-admin'
}

// Feedback Types
export const FEEDBACK_TYPES = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative'
}

// Local Storage Keys
export const STORAGE_KEYS = {
  FEEDBACK_GIVEN: 'feedbackGiven',
  USER_PREFERENCES: 'userPreferences'
}

// CSS Classes for consistency
export const CSS_CLASSES = {
  CONTAINER: 'container',
  SEARCH_FORM: 'search-form-compact',
  SEARCH_INPUT: 'search-input-compact',
  SEARCH_SUGGESTIONS: 'search-suggestions',
  PGIE_CONTAINER: 'pgie-container',
  ACTION_SECTIONS: 'action-sections-row'
}

// Validation Rules
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  MIN_NAME_LENGTH: 2,
  MAX_COMMENT_LENGTH: 1000
}
